import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';
import QS from 'qs';

class GetDatesState extends APIRequestState {
  getRequest(urlParams) {
    return this.ctx.sdk.get(`/v2/dates?${QS.stringify(urlParams)}`);
  }
}

class DatesState {
  @lazyInitialize @nonenumerable getDates = new GetDatesState(this.ctx);

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {}
}

export default DatesState;



// WEBPACK FOOTER //
// ./spa/state/dates.jsx